module.exports = __webpack_public_path__ + "img/ISFP.0a54d5ca.png";